import React, { useEffect, useState } from 'react';
import { IReportBuilderReport, NEW_REPORT_LABELS, ReportTypes } from 'views/ReportBuilder/constants';
import { NSCheckbox, NSLabel, NSSelect } from 'bricks';
import { useGetBackOfEnvelopeScenarios } from 'views/DealDashboard/BOE/hooks/useGetBOEScenarios';
import { IOptionAnyValue } from 'bricks/types';
import ReportSaveCard from '../components/ReportSaveCard/ReportSaveCard';

export interface IProps {
    report: IReportBuilderReport;
    setNewReports: React.Dispatch<React.SetStateAction<IReportBuilderReport[]>>;
    orgId: string;
    dealId: number;
}
const DealBOESaveCard = ({
    report, setNewReports, orgId, dealId,
}: IProps) => {
    const [selectedScenarios, setSelectedScenarios] = useState<IOptionAnyValue[]>([]);
    const [isIncludePrintedOnDateChecked, setIsIncludePrintedOnDateChecked] = React.useState<boolean>(false);

    const { data: scenarios } = useGetBackOfEnvelopeScenarios({
        orgId,
        dealId,
    });

    const dropdownOptions = scenarios?.items.map(scenario => ({
        label: scenario.name,
        value: scenario.id,
    }));

    useEffect(() => {
        if (report.selectedBOEScenarioIds && scenarios?.items) {
            const matchingScenarios = scenarios.items
                .filter(scenario => report.selectedBOEScenarioIds?.includes(Number(scenario.id)))
                .map(scenario => ({
                    label: scenario.name,
                    value: scenario.id,
                }));
            setSelectedScenarios(matchingScenarios);
            setIsIncludePrintedOnDateChecked(!!report.includePrintedOnDate);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [report.selectedBOEScenarioIds, scenarios]);

    const handleSave = () => {
        setNewReports(prevReports => {
            const reportIndex = prevReports.findIndex(r => r.reportType === ReportTypes.DEAL_BACK_OF_EVENLOPE);

            if (reportIndex === -1) {
                return prevReports;
            }

            const updatedReports = [...prevReports];
            updatedReports[reportIndex] = {
                ...prevReports[reportIndex],
                isEditing: false,
                selectedBOEScenarioIds: selectedScenarios.map(scenario => scenario.value),
                selectedBOEScenarioNames: selectedScenarios.map(scenario => scenario.label),
                includePrintedOnDate: isIncludePrintedOnDateChecked,
            };
            return updatedReports;
        });
    };

    const handleCancel = () => {
        setNewReports(prevReports => {
            const reportIndex = prevReports.findIndex(r => r.reportType === ReportTypes.DEAL_BACK_OF_EVENLOPE);

            if (reportIndex === -1 || !prevReports[reportIndex]) {
                return prevReports;
            }

            const updatedReports = [...prevReports];
            const report = prevReports[reportIndex];

            if (report.selectedBOEScenarioIds && report.selectedBOEScenarioIds.length > 0) {
                updatedReports[reportIndex] = {
                    ...report,
                    isEditing: false,
                };
            } else {
                updatedReports.splice(reportIndex, 1);
            }

            return updatedReports;
        });
    };

    return (
        <ReportSaveCard
            header={NEW_REPORT_LABELS.DEAL_BACK_OF_EVENLOPE}
            description="A detailed export of your Deal Dashboard's Back of Envelope page."
            handleSave={handleSave}
            handleCancel={handleCancel}
        >
            <NSLabel>Select scenario</NSLabel>
            {dropdownOptions && (
                <NSSelect
                    className="mt-0"
                    name="Select scenario"
                    options={dropdownOptions}
                    value={selectedScenarios}
                    onChange={selected => setSelectedScenarios(selected ? [selected] : [])}
                />
            )}
            <hr />
            <NSCheckbox
                id="include-printed-on-date-deal-boe"
                checked={isIncludePrintedOnDateChecked}
                labelText="Include printed on date"
                callback={() => setIsIncludePrintedOnDateChecked(!isIncludePrintedOnDateChecked)}
            />
        </ReportSaveCard>
    );
};

export default DealBOESaveCard;
